import { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const useBrowserLayoutEffect = typeof document === "undefined" ? useEffect : useLayoutEffect;

/** Runs before page SEO's passive effects, including the legacy SEO components. */
export function SeoNavigationCleanup() {
  const { pathname } = useLocation();
  const previous = useRef(pathname);
  useBrowserLayoutEffect(() => {
    if (previous.current === pathname) return;
    previous.current = pathname;
    document.head.querySelectorAll('script[data-seo-id]:not([data-seo-id^="base-"])').forEach((tag) => tag.remove());
    document.head.querySelectorAll('meta[property^="article:"], meta[property^="og:video"], meta[property="og:image:width"], meta[property="og:image:height"], meta[name^="twitter:player"], meta[name="keywords"]').forEach((tag) => tag.remove());
  }, [pathname]);
  return null;
}
